import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row, DatePicker, Table, Button, notification, Spin } from "antd";
import { Select } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { CiSquarePlus } from "react-icons/ci";
import { v4 as uuidv4 } from "uuid";
import { dropdownService, invoiceReceiptService } from "../../../../../services";
import { useNavigate } from "react-router-dom";
import MaterialLikeSelect from "../../../../../components/MaterialLikeSelect";
import MaterialLikeInput from "../../../../../components/MaterialLikeInput";
import MaterialLikeDatePicker from "../../../../../components/MaterialLikeDatePicker";
import { changeDocumentTitle } from "../../../../../utils/title";

function AddRecepit() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [invoices, setInvoices] = useState([]);

  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [showBankField, setShowBankField] = useState(false);
  const [form] = Form.useForm();
  const [data2, setData2] = useState([
    {
      Id: uuidv4(),
      Advance_number: "",
      Description: "",
      "Collection Amount($)": "",
    },
  ]);
  const [data, setData] = useState([
    {
      Id: uuidv4(),
      "#": 1,
      Invoice_Number: null,
      Description: "",
      "Invoice_Amount($)": "",
      "Advance_Amount($)": "",
      "Collection_Amount($)": "",
      "Balance($)": "",
      "Payment Status": "",
    },
  ]);


  // const calculateBalance = (invoiceAmount, advanceAmount, collectionAmount,) => {
  //   const invoice = parseFloat(invoiceAmount) || 0;
  //   const advance = parseFloat(advanceAmount) || 0;
  //   const collection = parseFloat(collectionAmount) || 0;
  //   return (invoice - advance - collection).toFixed(2);
  // };

  const calculateBalance = (
    invoiceAmount,
    paidAmount,
    advanceAmount,
    collectionAmount
  ) => {
    return (
      Number(invoiceAmount || 0) -
      Number(paidAmount || 0) -
      Number(advanceAmount || 0) -
      Number(collectionAmount || 0)
    ).toFixed(2);
  };


  const calculateAdvanceLeft = () => {
    const totalAdvanceAmount = data.reduce(
      (total, row) => total + (parseFloat(row["Advance_Amount($)"]) || 0),
      0
    );

    return invoices?.advance_remaining - totalAdvanceAmount || 0;
  };

  const handleChange = (value, fieldName, record, dataType) => {

    const setDataFunction = dataType === 1 ? setData : setData2;
    const dataToModify = dataType === 1 ? data : data2;

    const updatedData = dataToModify.map((row) => {
      if (row.Id === record.Id) {

        let updatedRow = { ...row, [fieldName]: value };

        // If Collection Amount or Advance Amount changes, update Balance and Payment Status
        if (fieldName === "Collection_Amount($)" || fieldName === "Advance_Amount($)") {
          const invoiceAmount = Number(row["Invoice_Amount($)"] || 0);
          const paidAmount = Number(row.Paid_Amount || 0);
          const advanceAmount = fieldName === "Advance_Amount($)" ? parseFloat(value) || 0 : parseFloat(row["Advance_Amount($)"]) || 0;
          const collectionAmount = fieldName === "Collection_Amount($)" ? parseFloat(value) || 0 : parseFloat(row["Collection_Amount($)"]) || 0;

          const newBalance = (invoiceAmount - advanceAmount - collectionAmount - paidAmount).toFixed(2);

          // Determine Payment Status dynamically
          let paymentStatus;
          if (newBalance >= invoiceAmount) {
            paymentStatus = 0; // Not Paid
          } else if (newBalance == 0) {
            paymentStatus = 2; // Complete
          } else {
            paymentStatus = 1; // Partial
          }

          updatedRow = {
            ...updatedRow,
            "Balance($)": newBalance,
            "Payment Status": paymentStatus,
          };
        }


        return updatedRow;
      }
      return row;
    });

    setDataFunction(updatedData);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Invoice Number",
      dataIndex: "Invoice_Number",
      key: "Invoice_Number",
      render: (text, record) => (
        <Select
          notFoundContent={loading ? <Spin size="small" /> : "No data"}
          loading={loading}
          defaultValue={text}
          showSearch
          style={{ width: "100%" }}
          onChange={(value) => {
            handleInvoiceChange(value, record);
          }}
        >
          {invoices?.invoices?.map((fi) => (
            <Select.Option key={fi.id} value={fi.id}>
              {fi.id}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      render: (text, record) => (
        <Input.TextArea
          defaultValue={text}
          style={{ width: "100%" }}
          rows={2}
          onChange={(e) =>
            handleChange(e.target.value, "Description", record, 1)
          }
        />
      ),
    },
    {
      title: "Invoice Amount($)",
      dataIndex: "Invoice_Amount($)",
      key: "Invoice_Amount($)",
      render: (text) => {
        return <Input value={text} style={{ width: "100%" }} readOnly />;
      },
    },
    {
      title: "Advance Amount($)",
      dataIndex: "Advance_Amount($)",
      key: "Advance_Amount($)",
      render: (text, record) => (
        <Input
          type="number"
          value={text}
          style={{ width: "100%" }}
          onChange={(e) => {
            let newValue = e.target.value;
            const totalAdvanceUsed = data.reduce(
              (total, row) => (row.Id !== record.Id ? total + (parseFloat(row["Advance_Amount($)"]) || 0) : total),
              0
            );
            const advanceLeft = invoices.advance_remaining - totalAdvanceUsed;

            if (newValue > advanceLeft) {
              newValue = 0;
            }
            handleChange(newValue, "Advance_Amount($)", record, 1)
            setData((prevData) =>
              prevData.map((row) =>
                row.Id === record.Id
                  ? {
                    ...row,
                    "Advance_Amount($)": newValue,
                    "Balance($)": calculateBalance(
                      row["Invoice_Amount($)"],
                      row.Paid_Amount,        // ✅ BACKEND PAID
                      newValue,
                      row["Collection_Amount($)"]
                    )

                    // "Balance($)": calculateBalance(
                    //   row["Invoice_Amount($)"],
                    //   newValue,
                    //   row["Collection_Amount($)"],
                    // ),
                  }
                  : row
              )
            );
          }
          }
        />
      ),
    },
    {
      title: "Collection Amount($)",
      dataIndex: "Collection_Amount($)",
      key: "Collection_Amount($)",
      render: (text, record) => (
        <Input
          type="number"
          value={text}
          style={{ width: "100%" }}
          onChange={(e) => {
            const newValue = e.target.value;
            handleChange(newValue, "Collection_Amount($)", record, 1);
            setData((prevData) =>
              prevData.map((row) =>
                row.Id === record.Id
                  ? {
                    ...row,
                    "Collection_Amount($)": newValue,
                    "Balance($)": calculateBalance(
                      row["Invoice_Amount($)"],
                      row.Paid_Amount,        // ✅ BACKEND PAID
                      row["Advance_Amount($)"],
                      newValue
                    )
                    // "Balance($)": calculateBalance(
                    //   row["Invoice_Amount($)"],
                    //   row["Advance_Amount($)"],
                    //   row["amount($)"],
                    //   newValue
                    // ),
                  }
                  : row
              )
            );
          }}
        />
      ),
    },
    {
      title: "Balance($)",
      dataIndex: "Balance($)",
      key: "Balance($)",
      render: (text) => (
        <Input value={text} style={{ width: "100%" }} readOnly />
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "Payment Status",
      key: "Payment Status",
      render: (text, record) => {
        return (
          <Select
            value={text}
            style={{ width: "100%" }}
            onChange={(value) => {
              handleChange(value, "Payment Status", record, 1)
            }
            }
          >
            <Select.Option value={0}>Not Paid</Select.Option>
            <Select.Option value={1}>Partial</Select.Option>
            <Select.Option value={2}>Complete</Select.Option>
          </Select >
        );
      },
    },
    {
      title: (
        <div>
          <DeleteOutlined style={{ fontSize: "18px" }} />
        </div>
      ),
      key: "Delete",
      render: (text, record, index) => {
        if (data.length === 1) return null;
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => handleDeleteRow(record.Id)}
          >
            <DeleteOutlined />
          </Button>
        );
      },
    },
  ];

  const columns2 = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Advanced Number",
      dataIndex: "Advance_number",
      key: "Advance_number",
      render: (text, record) => (
        <Input
          value={text}
          style={{ width: "100%" }}
          onChange={(e) =>
            handleChange(e.target.value, "Advance_number", record, 2)
          }
        />
      ),
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      render: (text, record) => (
        <Input.TextArea
          defaultValue={text}
          style={{ width: "100%" }}
          rows={2}
          onChange={(e) =>
            handleChange(e.target.value, "Description", record, 2)
          }
        />
      ),
    },
    {
      title: "Collection Amount($)",
      dataIndex: "Collection_Amount($)",
      key: "Collection_Amount($)",
      render: (text, record) => (
        <Input
          defaultValue={text}
          style={{ width: "100%" }}
          onChange={(e) =>
            handleChange(e.target.value, "Collection_Amount($)", record, 2)
          } // Tracking change in data2
        />
      ),
    },
    {
      title: (
        <div>
          <DeleteOutlined style={{ fontSize: "18px" }} />
        </div>
      ),
      key: "Delete",
      render: (text, record, index) => {
        if (data2.length === 1) return null;
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => handleDeleteRow2(record.Id)}
          >
            <DeleteOutlined />
          </Button>
        );
      },
    },
  ];

  const handleAddRow = () => {
    setData((prevData) => [
      ...prevData,
      {
        Id: uuidv4(),
        "#": (prevData.length + 1).toString(),
        Invoice_Number: null,
        Description: "",
        "Invoice_Amount($)": "",
        "Advance_Amount($)": "",
        "Collection_Amount($)": "",
        "Balance($)": "",
        "Payment Status": "",
      },
    ]);
  };

  const handleAddRow2 = () => {
    const lastAdvanceNumber =
      data2.length > 0 ? data2[data2.length - 1].Advance_number : 0;

    setData2([
      ...data2,
      {
        Id: uuidv4(),
        Advance_number: lastAdvanceNumber + 1,
        Description: "",
        "Collection Amount($)": "",
      },
    ]);
  };

  const handleDeleteRow = (Id) => {
    setData(data.filter((item) => item.Id !== Id));
  };

  const handleDeleteRow2 = (Id) => {
    setData2(data2.filter((item) => item.Id !== Id));
  };

  const handlePaymentChange = (value) => {
    if (value === 1) {
      setShowBankField(true);
    } else {
      setShowBankField(false);
    }
  };

  const getCompanies = async () => {
    const response = await dropdownService.fetchCompanies();
    if (response.success) {
      setCompanies(response.data);
    }
  };

  const getCustomer = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      const filter = response.data
        .filter((data) => data.isActive === 1)
        .sort((a, b) =>
          a.name.toUpperCase().localeCompare(b.name.toUpperCase())
        );

      const capitalizedFilter = filter.map((customer) => ({
        ...customer,
        name: customer.name.toUpperCase(),
      }));
      setCustomers(capitalizedFilter);
    }
  };

  const getPaymentModes = async () => {
    const response = await dropdownService.fetchPaymentModes();
    if (response.success) {
      setPaymentModes(response.data);
    }
  };

  const getBanks = async () => {
    const response = await dropdownService.fetchBanks();
    if (response.success) {
      setBanks(response.data);
    }
  };

  const getInvoices = async (id) => {
    setLoading(true)
    const response = await dropdownService.fetchRemainingInvoices(id);
    setLoading(false)
    if (response.success) {
      setInvoices(response.data);
      setData2((prevData) => [
        {
          ...prevData[0],
          Advance_number: response.data.advance_payment_id,
        },
        ...prevData.slice(1),
      ]);
    }
  };

  const handleChangeCustomer = async (value) => {
    setInvoices([]);
    getInvoices(value);
  };
  const calculateTotalInvoiceAmount = () => {
    return data.reduce(
      (total, row) => total + (parseFloat(row["Invoice_Amount($)"]) || 0),
      0
    );
  };

  const calculateTotalCollectionAmount = () => {
    return data.reduce(
      (total, row) => total + (parseFloat(row["Collection_Amount($)"]) || 0),
      0
    );
  };

  const handleInvoiceChange = (value, record) => {
    const selectedInvoice = invoices?.invoices?.find(
      (invoice) => invoice.id === value
    );
    if (selectedInvoice) {
      const updatedData = data.map((row) =>
        row.Id === record.Id
          ? {
            ...row,
            Invoice_Number: selectedInvoice.id,
            "Invoice_Amount($)": selectedInvoice.total || "",
            Paid_Amount: selectedInvoice.amounts, // ✅ STORE BACKEND PAID
            "Collection_Amount($)": 0,
            "Advance_Amount($)": 0,
            "Payment Status": selectedInvoice.status || "",
            "Balance($)": selectedInvoice.total - selectedInvoice.amounts || "",
          }
          : row
      );
      setData(updatedData);
    }
  };

  const onFinish = async (values) => {
    setLoading(true)
    const payload = {
      ...values,
      receipt_date: values.receipt_date ? values.receipt_date.format("YYYY-MM-DD") : null,
      payment_date: values.payment_date ? values.payment_date.format("YYYY-MM-DD") : null,
      payment_mode_name: paymentModes.find(
        (mode) => mode.id === values.payment_mode
      ).name,
      invoice_id: data.map((item) => item.Invoice_Number),
      description: data.map((item) => item.Description),
      adjust_amount: data.map((item) => item["Advance_Amount($)"]),
      amount: data.map((item) => item["Collection_Amount($)"]),
      balance: data.map((item) => item["Balance($)"]),
      status: data.map((item) => item["Payment Status"]),
      advance_payment: data2.map((item) => item.Advance_number),
      advance_description: data2.map((item) => item.Description),
      advance_amount: data2.map((item) => item["Collection_Amount($)"]),
    };

    const response = await invoiceReceiptService.addreceipt(payload);
    setLoading(false)
    if (response.success) {
      notification.success({ message: "Added Successfully!", description: response.message, placement: "topRight" });
      navigate(`/accounts/receipt-collects`)
    }
  };

  const initialize = async () => {
    getBanks();
    getCustomer();
    getPaymentModes();
    getCompanies();
  };

  useEffect(() => {
    changeDocumentTitle("Add Invoice Receipt");
    initialize();
  }, []);

  return (
    <div
      style={{
        padding: "0 14px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row
        gutter={26}
        style={{
          // backgroundColor: '#FBFBFB',
          marginBottom: 15,
          padding: "10px",
          borderRadius: "4px",
          borderBottom: "1px solid #E8E8E9",
        }}
      >
        <Col span={12}>
          <h1 style={{ fontWeight: "bold" }}>Add Receipt</h1>
        </Col>
      </Row>

      <Form
        // requiredMark={false}
        layout="vertical"
        onFinish={onFinish}
        form={form}
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              name="user_id"
              rules={[
                {
                  required: true,
                  message: "Please input!",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Customer Name"
                required
                value={form.getFieldValue("user_id")}
                onChange={(value) => {
                  handleChangeCustomer(value)
                  form.setFieldValue('user_id', value)
                }}
                options={customers?.map((cust) => ({
                  id: cust.id,
                  value: cust.id,
                  label: cust.name,
                }))}
              />
              {/* <Select
                placeholder="No Customer"
                showSearch
                optionFilterProp="children"
                onChange={(value) => handleChangeCustomer(value)}
              >
                {customers?.map((cust) => (
                  <Select.Option key={cust.id} value={cust.id}>
                    {cust.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="reference_number">
              <MaterialLikeInput
                label="Customer Ref. #"
                value={form.getFieldValue("reference_number")}
                onChange={(e) => form.setFieldValue("reference_number", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="receipt_date" rules={[{ required: true, message: "Please select" }]}>
              <MaterialLikeDatePicker
                label="Receipt Date"
                required
                value={form.getFieldValue("receipt_date")}
                onChange={(date) => form.setFieldValue("receipt_date", date)}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="payment_date" rules={[{ required: true, message: "Please select" }]}>
              <MaterialLikeDatePicker
                label="Collection Date"
                required
                value={form.getFieldValue("payment_date")}
                onChange={(date) => form.setFieldValue("payment_date", date)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="payment_mode"
              rules={[
                {
                  required: true,
                  message: "Please input!",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Collection Mode"
                required
                value={form.getFieldValue("payment_mode")}
                onChange={(value) => form.setFieldValue('payment_mode', value)}
                options={paymentModes?.map((mode) => ({
                  id: mode.id,
                  value: mode.id,
                  label: mode.name,
                }))}
              />
              {/* <Select
                placeholder="No Customer"
                onChange={(value) => handlePaymentChange(value)}
              >
                {paymentModes?.map((mode) => (
                  <Select.Option key={mode.id} value={mode.id}>
                    {mode.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          {showBankField && (
            <Col span={8}>
              <Form.Item
                name="bank"
                rules={[
                  {
                    required: true,
                    message: "Please input!",
                  },
                ]}
              >
                <MaterialLikeSelect
                  label="Bank"
                  required
                  value={form.getFieldValue("bank")}
                  onChange={(value) => form.setFieldValue('bank', value)}
                  options={banks?.map((bank) => ({
                    id: bank.id,
                    value: bank.id,
                    label: bank.name,
                  }))}
                />
                {/* <Select placeholder="No Customer">
                  {banks?.map((bank) => (
                    <Select.Option key={bank.id} value={bank.id}>
                      {bank.name}
                    </Select.Option>
                  ))}
                </Select> */}
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Form.Item
              name="company"
              rules={[
                {
                  required: true,
                  message: "Please input!",
                },
              ]}
            >
              <MaterialLikeSelect
                label="Inter-Company"
                required
                value={form.getFieldValue("company")}
                onChange={(value) => form.setFieldValue('company', value)}
                options={companies?.map((comp) => ({
                  id: comp.id,
                  value: comp.id,
                  label: comp.name,
                }))}
              />
              {/* <Select placeholder="No Customer">
                {companies?.map((comp) => (
                  <Select.Option key={comp.id} value={comp.id}>
                    {comp.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={22} style={{ textAlign: "right" }}>
            <p style={{ fontWeight: "bold", fontSize: "16px" }}>
              Advance in Balance:
              <span style={{ fontWeight: "normal" }}>
                {" "}
                {invoices?.advance_remaining
                  ? `$${invoices?.advance_remaining}`
                  : 0}
              </span>
            </p>
          </Col>
          <Col span={24}>
            <div
              style={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                marginTop: 20,
              }}
            >
              <h1 style={{ fontWeight: "bold" }}>Invoice Collection</h1>
              <Table
                columns={columns}
                scroll={{ x: "max-content" }}
                dataSource={data}
                pagination={false}
                rowKey="Id"
                style={{ marginTop: "10px" }}
              />
              <div
                style={{ marginTop: 20 }}
                className="flex flex-col justify-center items-center"
              >
                <CiSquarePlus
                  style={{ cursor: "pointer", fontSize: "25px" }}
                  onClick={handleAddRow}
                />
              </div>
            </div>
          </Col>
          <div className="mt-5 flex justify-between gap-36 px-8" >
            <div>
              <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                Total Invoice Amount
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  ${calculateTotalInvoiceAmount()}
                </span>
              </p>
            </div>
            <div>
              <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                Total Collection Amount
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  ${calculateTotalCollectionAmount()}
                </span>
              </p>
            </div>
            <div>
              <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                Advance Left:
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  ${calculateAdvanceLeft()}
                </span>
              </p>
            </div>
          </div>
          <Col span={8} style={{ marginTop: 20, textAlign: "right" }}>

          </Col>
          <Col span={8} style={{ marginTop: 20, textAlign: "right" }}>

          </Col>
          <Col span={8} style={{ marginTop: 20, textAlign: "right" }}>

          </Col>
          <Col span={24}>
            <div
              style={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                marginTop: 20,
              }}
            >
              <h1 style={{ fontWeight: "bold" }}>Advanced Collection </h1>
              <Table
                columns={columns2}
                scroll={{ x: "max-content" }}
                dataSource={data2}
                pagination={false}
                rowKey="id"
                style={{ marginTop: "10px" }}
              />
              <div
                style={{ marginTop: 20 }}
                className="flex flex-col justify-center items-center"
              >
                <CiSquarePlus
                  style={{ cursor: "pointer", fontSize: "25px" }}
                  onClick={handleAddRow2}
                />
              </div>
            </div>
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              style={{ margin: 20 }}
              htmlType="submit"
              loading={loading}
            >
              Add Receipt
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default AddRecepit;
